import { InteractionDictionary } from 'src/api/interactions-dictionary/types';

import { List, Text } from '@mantine/core';
import { FC } from 'react';

type Props = {
  interactionDictionary: InteractionDictionary;
};

export const InteractionDictionaryDetails: FC<Props> = ({
  interactionDictionary,
}) => (
  <>
    <Text fw={500} size="lg">
      Details
    </Text>

    <List spacing="xs" listStyleType="none">
      <List.Item>
        <Text size="xs">
          Name:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.name}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Type:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.type}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Description:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.description || 'No description'}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Short Description:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.description_short || 'No short description'}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          About:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.about || 'No about information'}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Interaction Time:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.interaction_time} seconds
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Genre:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.genre.length > 0
              ? interactionDictionary.genre.join(', ')
              : 'No genres specified'}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Mode:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {interactionDictionary.mode.length > 0
              ? interactionDictionary.mode.join(', ')
              : 'No modes specified'}
          </Text>
        </Text>
      </List.Item>
    </List>
  </>
);
